import React from "react";
import { Search, X } from "lucide-react";

const UNAVAILABLE_TERMS = /^unavailable( products?)?$/;
export const FILTERS = [["all", "All Products"], ["available", "Available"], ["unavailable", "Unavailable"]];

// UI-only filtering of the vendor's own already-loaded products (no API / data changes).
export function filterProducts(products, query, filter) {
  const q = (query || "").trim().toLowerCase().replace(/\s+/g, " ");
  const termFilter = UNAVAILABLE_TERMS.test(q);
  const avail = termFilter ? "unavailable" : filter;
  const name = termFilter ? "" : q;
  const list = products.filter((p) => {
    const inStock = p.in_stock !== false;
    if (avail === "available" && !inStock) return false;
    if (avail === "unavailable" && inStock) return false;
    return !name || (p.name || "").toLowerCase().includes(name);
  });
  return { list, termFilter };
}

export default function ProductSearchBar({ query, setQuery, filter, setFilter, shown, total, termFilter }) {
  return (
    <div className="mb-4 space-y-2 min-w-0" data-testid="product-search-bar">
      <div className="relative">
        <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search name or “unavailable”"
          className="w-full rounded-full border border-slate-200 focus:border-emerald-500 focus:outline-none bg-white pl-9 pr-10 py-2 text-sm min-h-[40px] [&::-webkit-search-cancel-button]:hidden"
          aria-label="Search my products"
          data-testid="product-search-input"
        />
        {query && (
          <button type="button" onClick={() => setQuery("")} className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-full text-slate-500 hover:bg-slate-100" aria-label="Clear search" data-testid="product-search-clear">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {FILTERS.map(([id, label]) => (
          <button key={id} type="button" onClick={() => setFilter(id)} aria-pressed={filter === id}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold border min-h-[34px] transition-colors ${filter === id ? "bg-emerald-700 border-emerald-700 text-white" : "bg-white border-slate-200 text-slate-600 hover:border-emerald-400"}`}
            data-testid={`product-filter-${id}`}>
            {label}
          </button>
        ))}
        <span className="text-xs text-slate-500 ml-auto" data-testid="product-search-count">{shown} of {total} products</span>
      </div>
      {termFilter && <div className="text-xs text-amber-700" data-testid="product-search-term-hint">Showing all unavailable products</div>}
    </div>
  );
}
